var _a;
import { getLocaleFromQueryString } from 'svelte-i18n';
export const TARGET_HTML_SELECTOR = process.env.TARGET_HTML_SELECTOR || 'eqs-cms-irtools-contactform';
export const COMPANY_ID = process.env.COMPANY_ID || '';
export const FALLBACK_LOCALE = process.env.FALLBACK_LOCALE || 'en';
export const SUBSCRIPTION_TYPE = process.env.SUBSCRIPTION_TYPE || 'alert';
export const SUBSCRIPTION_TOKEN_PARAM_NAME = process.env.SUBSCRIPTION_TOKEN_PARAM_NAME || 'token';
export const LOCALE_PARAM_NAME = process.env.LOCALE_PARAM_NAME || 'lang';
export const RECAPTCHA_SITE_KEY = process.env.RECAPTCHA_SITE_KEY || '';
export const RECAPTCHA_TARGET_HTML_ID = process.env.RECAPTCHA_TARGET_HTML_ID ||
    'eqs-cms-irtools-contactform-recaptcha';
export const AUTH_CLIENT_ID = process.env.AUTH_CLIENT_ID || '';
export const AUTH_PROVISION_KEY = process.env.AUTH_PROVISION_KEY || '';
export const AUTH_AUTHENTICATED_USER_ID = process.env.AUTH_AUTHENTICATED_USER_ID || '';
export const AUTH_RESPONSE_TYPE = process.env.AUTH_RESPONSE_TYPE || 'token';
export const API_ENDPOINT = process.env.API_ENDPOINT || '';
export const API_PREFIX = process.env.API_PREFIX || '';
/**
 * This locale will take control
 * of this application's language,
 * @var string
 */
export const LOCALE = ((_a = document.querySelector(TARGET_HTML_SELECTOR)) === null || _a === void 0 ? void 0 : _a.getAttribute('lang')) ||
    document.documentElement.lang ||
    getLocaleFromQueryString(LOCALE_PARAM_NAME) ||
    FALLBACK_LOCALE;
